import { suffixBaseURL } from '@/config/api'
import { httpClient } from '@/shared/infra/adapters/axios/axios'

export interface GetAgenciesResponse {
  companies: {
    alphaId: string
    qtdCompaniesChilds: number
    name: string
    active: boolean
    cityName: string
    stateCode: string
  }[]
}

export async function getAgencies() {
  const { data } = await httpClient.get<GetAgenciesResponse>(
    `${suffixBaseURL.myBusiness}/agencies`,
  )

  if (!data.companies || data.companies.length === 0) return []

  return data.companies
}
